import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 flex items-center min-h-[90vh] overflow-hidden" data-id="element-283">
      {/* Background Image with Parallax */}
      <div className="absolute inset-0 z-0 scale-110" style={{
      transform: `translateY(${scrollY * 0.4}px)`
    }} data-id="element-284">
        <img src="https://cdn.rawproductionsgmbh.de/2n/home/header.jpg" alt="Zahnärztliche Fortbildung" className="w-full h-full object-cover object-center" data-id="element-285" />
        <div className="absolute inset-0 bg-[#1a1a1a]/70 mix-blend-multiply" data-id="element-286"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-[#1a1a1a]/40 to-transparent" data-id="element-287"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-288">
        <div className="max-w-3xl mx-auto text-center" data-id="element-289">
          <ScrollReveal variant="up" delay={100} data-id="element-290">
            <span className="inline-block py-1.5 px-4 rounded-full bg-[#59d0d4]/20 text-[#59d0d4] text-xs sm:text-sm font-extrabold tracking-wider sm:tracking-widest uppercase mb-6 border border-[#59d0d4]/30 backdrop-blur-sm" data-id="element-291">
              2N | Fortbildungsinstitut
            </span>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} data-id="element-292">
            <h1 className="text-3xl md:text-6xl lg:text-7xl text-white leading-tight mb-6 tracking-tight font-[600]" data-id="element-293">
              Akademie für zahnärztliche Fortbildung
            </h1>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={500} data-id="element-294">
            <p className="text-base sm:text-lg md:text-2xl text-slate-300 mb-10 font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-295">
              Ihre Kurse & Curriculum in Bayern, Nürnberg. Praxisnahe,
              zertifizierte Weiterbildung für Zahnärzte, Oralchirurgen und
              Praxisteams.
            </p>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={700} data-id="element-296">
            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4" data-id="element-297">
              <a href="#kurse" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-[0_0_20px_rgba(59,119,128,0.4)]" data-id="element-298">
                Kurse entdecken
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-299" />
              </a>
              <a href="#curriculum" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-white/10 hover:bg-white/20 border border-white/30 backdrop-blur-sm transition-all hover:scale-105" data-id="element-300">
                Zum Curriculum
              </a>
              <Link to="/kontakt" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-[#59d0d4] hover:bg-[#4abfc3] transition-all hover:scale-105 shadow-lg text-slate-900" data-id="element-301">
                Jetzt Kursplan sichern
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-302" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}